import __request__ from "routing/request";
export function searchRelativeChunked(query, range, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/relative", null, { "query": query, "range": range, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function searchRelative(query, range, limit, offset, filter, fields, streams, sort, decorate = true, requestOptions) {
  return __request__("GET", "/search/universal/relative", null, { "query": query, "range": range, "limit": limit, "offset": offset, "filter": filter, "fields": fields, "streams": streams, "sort": sort, "decorate": decorate }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportSearchRelativeChunked(query, range, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/relative/export", null, { "query": query, "range": range, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
